import type {
  LegalAgreementApi,
  LegalAgreementContractedApiQuery,
  LegalAgreementContractorApiQuery,
} from "@/Modules/Models/Api/LegalAgreement";
import type { LegalAgreement } from "@/Modules/Models/Domain/LegalAgreement";

import LegalAgreementTransformer from "@/Modules/Transformers/LegalAgreement";

import { get2, patch2 } from "./utils/FunctionalTherapyApi";

const legalAgreementTransformer = LegalAgreementTransformer;

export function getHtml(uuid: string, contractUuid: string): Promise<string | null> {
  return get2<void, LegalAgreementApi>(
    `/v2.0/contracts/${contractUuid}?contractor_uuid=${uuid}&view=html`
  ).then((resp) => {
    const { html } = resp;

    if (typeof html === "string" && html.trim().length > 0) {
      return html;
    } else {
      return null;
    }
  });
}

export function getByUuid(uuid: string, contractUuid: string): Promise<LegalAgreement> {
  return get2<void, LegalAgreementApi>(
    `/v2.0/contracts/${contractUuid}?contractor_uuid=${uuid}&view=html`
  ).then((resp) => {
    return legalAgreementTransformer.toDomain(resp);
  });
}

export async function getAgreements(
  customerId: string,
  userId: string | undefined
): Promise<LegalAgreement[]> {
  const endpoint = userId
    ? `/v2.0/contracts?contracted_uuid=${userId}&contractor_uuid=${customerId}&page_size=1000`
    : `/v2.0/contracts?contractor_uuid=${customerId}&page_size=1000`;
  const agreements = await get2<void, LegalAgreementApi[]>(endpoint);

  return agreements.map((la) => legalAgreementTransformer.toDomain(la));
}

export async function acceptAgreement(uuid: string): Promise<LegalAgreement> {
  const la = await patch2<LegalAgreementContractorApiQuery, LegalAgreementApi>(`/v2.0/contracts/${uuid}`, {
    contractor_signed: true,
  });

  return legalAgreementTransformer.toDomain(la);
}

export async function acceptAgreementTherapist(uuid: string): Promise<LegalAgreement> {
  const la = await patch2<LegalAgreementContractedApiQuery, LegalAgreementApi>(`/v2.0/contracts/${uuid}`, {
    contracted_signed: true,
  });

  return legalAgreementTransformer.toDomain(la);
}
